import React, {useEffect, useState, useCallback} from 'react';
import ipfs from "decentralized/Ipfs.js";
import {getPacksIncludedIn, newPack} from "packs/packs.js";


export const usePacks = (contentHash, showing, sample, preset) => {
    let [packsIncludedIn, setPacksIncludedIn] = useState([]);
    
    const createNewPack = useCallback(() => {
    }, [contentHash]);

    useEffect(() => {
        if (showing) {
            getPacksIncludedIn(contentHash)
                .then(setPacksIncludedIn);
        }
    }, [contentHash, showing]);

    const addToPack = useCallback((pack) => {
        let hash = pack.packHash;
        let title = pack.title;
        if (sample) {
            sample.packs.push(title);
        }
        ipfs.getJson(hash)
            .then(
                json => {
                    let samples = json.samples || [];
                    let presets = json.presets || [];
                    if (sample) {
                        samples = [...samples, sample.getId()];
                    } 
                    if (preset) {
                        presets = [... presets, preset.contentHash];
                    }
                    newPack(
                        pack.title,
                        json.description,
                        samples,
                        presets,
                        hash);
                });
    }, [sample, preset]);

    return {createNewPack, addToPack, packsIncludedIn};
};
